/* istanbul ignore file */
import React from 'react';
import { CreateForm } from 'framework/form';
import CareerDevelopmentReviewForm from 'domain/people/career/development/createupdate/CareerDevelopmentReviewForm';
import useCareerDevelopmentReviewService from 'domain/people/career/development/shared/careerDevelopmentReviewService';
import { OneStopPageLayout } from 'domain/shared/oneStop';

type CustomRequestFormProps = {
  openModal: (content: any, title?: string) => void;
  requestId?: string;
};

const OneStopCareerDevelopmentReview = ({ openModal }: CustomRequestFormProps) => {
  const { create, getOneStopValidationSchema } = useCareerDevelopmentReviewService();

  return (
    <CreateForm
      submitFormFunc={create}
      afterSubmit={{
        execute: response => {
          // @ts-ignore
          openModal(response.message);
        },
      }}
      getValidationSchemaFunc={getOneStopValidationSchema}
    >
      <OneStopPageLayout>
        <CareerDevelopmentReviewForm />
      </OneStopPageLayout>
    </CreateForm>
  );
};

export default OneStopCareerDevelopmentReview;
